import s from './StepHeader.module.css';
import { type LanguageCore, Text } from '../Language/Language';
import { type Direction, Flex } from '@repo/ui/Flex';

export const StepHeader = ({
  title,
  subtitle,
  direction = 'column',
}: {
  title: LanguageCore;
  subtitle: LanguageCore;
  direction?: Direction;
}) => (
  <Flex className={s.wrapper} direction={direction} gap="g-12">
    <h1 className={s.title}>
      <Text {...title} />
    </h1>
    <h2 className={s.subtitle}>
      <Text {...subtitle} />
    </h2>
  </Flex>
);
